














































import { defineComponent, PropType } from '@vue/composition-api'
import { CatalogItem } from '@/store/socialStream/postApiRequestHelper'
import { BImg } from 'bootstrap-vue'
import PostStore from '@/store/socialStream/socialStreamPost'
import SocialStreamConfigStore from '@/store/socialStream/socialStreamConfig'
import CatalogItemsLinkerStore from '@/store/catalogItemsLinker/catalogItemsLinker'

export default defineComponent({
  name: 'ProductRow',
  components: { BImg },
  props: {
    product: {
      type: Object as PropType<CatalogItem>,
      required: true,
    },
    linkedProductsIds: {
      type: Array,
      required: true,
    },
    linkItemFn: {
      type: Function,
      required: true,
    },
    detachItemFn: {
      type: Function,
      required: true,
    },
  },
  computed: {
    calculateHeight(): string {
      return '100%'
      const heightInPixels = Math.ceil((window.innerHeight - 200) / 8)
      return `${heightInPixels}px`
    },
    calculateMaxWidth(): string {
      console.log(window.innerWidth)
      const widthInPixels = Math.ceil((window.innerWidth) / 6)
      return `${widthInPixels}px`
    },
    isNotAssigned(): boolean {      

      return this.checkIfAssigned(this.product.id) === false
    }    
  },
  methods: {

    checkIfAssigned(productId: string): boolean {
      return this.linkedProductsIds.includes(productId)
    },
    detachItem(itemId: string) {
      CatalogItemsLinkerStore.dispatch('detachItems', itemId)
    },
    checkIfIsAssigned(itemId: string) {      
      return Array.isArray(CatalogItemsLinkerStore.state.linkedIds) ? CatalogItemsLinkerStore.state.linkedIds.includes(itemId) : false
    }
  },
})
